import React, { Component } from 'react';
import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';

const plugins = { dvr: validatorjs };

const fields = ['toEmails', 'ccEmails', 'bccEmails', 'fromEmail', 'subject'];
const labels = {
    toEmails: 'To',
    ccEmails: 'CC',
    bccEmails: 'BCC',
    fromEmail: 'From',
    subject: 'Subject',
};
const bindings = {
    toEmails: 'TagsInput',
    ccEmails: 'TagsInput',
    bccEmails: 'TagsInput',
};

const types = {};
const rules = { toEmails: 'required', fromEmail: 'required', subject: 'required' };
const defaults = { toEmails: [], fromEmails: '', ccEmails: [], bccEmails: [] };
const values = { toEmails: [], fromEmails: '', ccEmails: [], bccEmails: [] };
const extra = { listingDate: 'date', agent: 'array' };
const disabled = {
    // 'toEmails': true,
    // 'ccEmails': true,
    // 'bccEmails': true,
    fromEmail: true,
    // 'subject': true,
};

const tagsInputOnChange = (form, field, list, item) => {
    const updateObj = {};
    updateObj[field.key] = list;
    form.update(updateObj);
};

class SendEmailForm extends MobxReactForm {
    bindings() {
        const me = this;
        return {
            TagsInput: ({ $try, field, props }) => ({
                id: $try(props.id, field.id),
                name: $try(props.name, field.name),
                value: $try(props.value, field.value),
                errorText: field.validating ? props.validatingText : $try(props.error, field.error),
                errorStyle: field.validating ? { background: 'yellow', color: 'black' } : {},
                onChange: (list, item) => {
                    tagsInputOnChange(me, field, list, item);
                },
            }),
            Textarea: {
                id: 'id',
                name: 'name',
                value: 'value',
                onChange: 'onChange',
            },
        };
    }
}

export default function(options) {
    return new SendEmailForm(
        Object.assign(
            {
                fields,
                disabled,
                defaults,
                values,
                rules,
                bindings,
                labels,
                types,
                extra,
            },
            options || {}
        ),
        { plugins }
    );
}



// WEBPACK FOOTER //
// ./src/components/send-email-form.js